const getNetworkSpeedInMbps = async () => {
  // Simulate network speed test for download
  const startTimeDownload = Date.now();
  const testDownloadUrl = 'https://qiniu.laway.cn/mingxuan_20240624.zip'; // Replace with a real file URL for actual testing
  const responseDownload = await fetch(testDownloadUrl, { method: 'HEAD' });
  const contentLengthDownload = responseDownload.headers.get('content-length');

  // Simulate download for a period of time to calculate speed
  await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate 1 second delay

  const endTimeDownload = Date.now();
  const durationDownload = (endTimeDownload - startTimeDownload) / 1000; // in seconds
  const sizeInMbpsDownload = (contentLengthDownload * 8) / (1024 * 1024) / durationDownload;

  // Simulate network speed test for upload
  const startTimeUpload = Date.now();
  const testUploadUrl = 'https://lpcsoft.lvpin100.com/api/v1/uplfoad/file'; // Replace with a real file URL for actual testing
  // const testUploadUrl = 'http://localhost:3001/api/v1/uplfoad/file'; // Replace with a real file URL for actual testing
  const dummyData = new Uint8Array(1024 * 1024).fill(0); // 1 MB of dummy data
  await fetch(testUploadUrl, {
    method: 'POST',
    body: dummyData,
    headers: { 'Content-Type': 'application/octet-stream' }
  });

  const endTimeUpload = Date.now();
  const durationUpload = (endTimeUpload - startTimeUpload) / 1000; // in seconds
  const sizeInMbpsUpload = (dummyData.length * 8) / (1024 * 1024) / durationUpload;

  return { download: sizeInMbpsDownload, upload: sizeInMbpsUpload };
};

export const testNetworkSpeed = () => {
  return new Promise((resolve) => {
      const controller = new AbortController();
      const signal = controller.signal;
    
      const speeds = [];
      const intervalId = setInterval(async () => {
        try {
          const networkSpeed = await getNetworkSpeedInMbps({ signal });
          speeds.push(networkSpeed);
          if (networkSpeed) resolve(networkSpeed);
        } catch (error) {
          console.error('Network speed test error:', error);
        }
        if (speeds.length === 3) {
          clearInterval(intervalId);
          const averageSpeed = speeds.reduce((a, b) => a + b, 0) / speeds.length;
          if (averageSpeed) resolve(averageSpeed);
        }
      }, 1000);
    
      setTimeout(() => {
        clearInterval(intervalId);
        if (speeds.length < 3) {
          const averageSpeed = speeds.reduce((a, b) => a + b, 0) / speeds.length;
          if (averageSpeed) resolve(averageSpeed);
        }
      }, 3000);
  });
};
